<template>
    <!-- 回到顶部 -->
    <div class="gotoTop">
        <p><i></i><span>回到顶部</span></p>
    </div>
</template>
<script>
    export default{
        mounted(){
            $(document).ready(function(){
                // 回到顶部功能
                $(window).scroll(function(){
                    var scrolltop = $(document).scrollTop();
                    if(scrolltop > 300){
                        $(".gotoTop").show();
                    }else{
                        $(".gotoTop").hide();
                    }
                })
                $(".gotoTop").click(function(){
                    $('body, html').animate({
                        scrollTop: 0
                    }, 800);
                })
            })
        }
    }
</script>
<style scoped>
.gotoTop{
        padding: 10px;
        width: auto;
        border: none;
        background: #ebebeb;
        color: #ffffff;
        width: 42px;
        height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-align: right;
        transition: 0.5s;
        cursor: pointer;
    }

    .gotoTop p{
        width: 108px;
        overflow: hidden;
        position: absolute;
        right: 10px;
    }

     .gotoTop span{
         /*display: none;*/
         float: right
     }

    .gotoTop i{
        display: inline-block;
        width: 22px;
        height: 22px;
        vertical-align: middle;
        background: url(../assets/img/icons/top.png) no-repeat center;
        margin-left: 10px;
        float: right;
    }

    .gotoTop:hover{
        background: #941800;
        width: 108px;
    }

    @media (max-width: 768px){
        .gotoTop{
            right: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/gotoTop.vue